import { isCachedShape, isModelShape, type ShapeJSON } from '@takeshape/schema';

export function showInDataTab(shape: ShapeJSON): boolean {
  return isModelShape(shape) || isCachedShape(shape);
}
